module.exports = __webpack_public_path__ + "img/price_img_02.2da9e76b.png";